import React from "react";
import { useSelector } from "react-redux";
import { Collapse } from "antd";
import { CheckOutlined } from "@ant-design/icons";

import { trb, translationGroups } from "@utilities";
import { selectSortedKycAppDocumentList } from "@redux";

import { RequestedDocsListItem } from "../Elements/RequestedDocsListItem";

const { Panel } = Collapse;

export const UploadRequestedAppDocs = ({ goToDocApprovalState, fileList }) => {
  const userDocuments = useSelector(selectSortedKycAppDocumentList);

  return (
    <div className="w-100">
      <div className="w-100">
        <span className="eb_fs_16">
          {trb(translationGroups.Messages + "UploadApplicationDocument")}
        </span>
      </div>
      <div className="w-100 mb-3 upload_card">
        <Collapse defaultActiveKey={["1"]} accordion>
          {(fileList.length > 0 ? fileList : userDocuments).map(
            ({ documentType, completed, applicationDocumentId, fileOptions }, i) => (
              <Panel
                header={documentType}
                key={i + 1}
                extra={completed && <CheckOutlined className="check-icon" />}
                collapsible={completed ? "disabled" : ""}
              >
                {!completed && (
                  <RequestedDocsListItem
                    applicationDocumentId={applicationDocumentId}
                    fileOptions={fileOptions}
                    documentType={documentType}
                    goToDocApprovalState={goToDocApprovalState}
                  />
                )}
              </Panel>
            )
          )}
        </Collapse>
      </div>
    </div>
  );
};
